export const CHAT_REACTION_OPTIONS = [
  { emoji: "❤️", key: "heart", labelKey: "chats.event_chat.reactions.heart" },
  { emoji: "👌", key: "ok", labelKey: "chats.event_chat.reactions.ok" },
  { emoji: "🔥", key: "fire", labelKey: "chats.event_chat.reactions.fire" },
  { emoji: "😊", key: "smile", labelKey: "chats.event_chat.reactions.smile" },
  { emoji: "👍", key: "thumbs_up", labelKey: "chats.event_chat.reactions.thumbs_up" },
  { emoji: "😁", key: "grin", labelKey: "chats.event_chat.reactions.grin" },
  { emoji: "😢", key: "sad", labelKey: "chats.event_chat.reactions.sad" },
  { emoji: "👎", key: "thumbs_down", labelKey: "chats.event_chat.reactions.thumbs_down" },
];

const REACTION_ORDER = new Map(
  CHAT_REACTION_OPTIONS.map((option, index) => [option.emoji, index])
);

export function isSupportedChatReaction(emoji) {
  return REACTION_ORDER.has(String(emoji || ""));
}

export function normalizeMessageReactions(rawReactions, currentUserId = null) {
  const list = Array.isArray(rawReactions) ? rawReactions : [];
  const myUserId =
    currentUserId == null || Number.isNaN(Number(currentUserId))
      ? null
      : Number(currentUserId);

  const merged = new Map();

  for (const raw of list) {
    const emoji = String(raw?.emoji || "").trim();
    if (!REACTION_ORDER.has(emoji)) continue;

    const userIds = Array.isArray(raw?.user_ids)
      ? raw.user_ids
          .map((value) => Number(value || 0))
          .filter((value) => Number.isFinite(value) && value > 0)
      : [];

    const rawCount = Number(raw?.count || 0);
    const rawIsSelf = typeof raw?.is_self === "boolean" ? raw.is_self : null;
    const isSelf =
      rawIsSelf != null ? rawIsSelf : myUserId != null && userIds.includes(myUserId);
    const count = Math.max(
      Number.isFinite(rawCount) ? rawCount : 0,
      userIds.length,
      isSelf ? 1 : 0
    );

    if (count <= 0) continue;

    const prev = merged.get(emoji);
    if (prev) {
      prev.count += count;
      prev.is_self = prev.is_self || isSelf;
      continue;
    }

    merged.set(emoji, {
      emoji,
      count,
      is_self: isSelf,
    });
  }

  return Array.from(merged.values()).sort(
    (a, b) =>
      (REACTION_ORDER.get(a.emoji) ?? Number.MAX_SAFE_INTEGER) -
      (REACTION_ORDER.get(b.emoji) ?? Number.MAX_SAFE_INTEGER)
  );
}
